// extracted by mini-css-extract-plugin
export var chevron = "_3b-2";
export var chevronCollapsed = "_3b-3";
export var collapsibleHeader = "_3b-1";
export var container = "_3b-0";